export enum ExpenseCategoryEnum {
    Rent = 1,
    Utilities = 2,
    Food = 3,
    Medicines = 4,
    FamilyOrChildren = 5,
    Household = 6,
}
